import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { QrCode, Download } from 'lucide-react';

function buildVCard(lead) {
  const name = lead.company_name || '';
  const phone = lead.contact_info?.general_phone || lead.contact_info?.contact_phone || lead.phone || '';
  const email = lead.contact_info?.general_email || lead.email || '';
  const website = lead.website || '';
  const location = lead.location || '';
  const contactPerson = lead.contact_info?.contact_person || '';
  const contactPosition = lead.contact_info?.contact_position || '';

  const lines = ['BEGIN:VCARD', 'VERSION:3.0'];
  if (contactPerson) {
    const parts = contactPerson.trim().split(/\s+/);
    const lastName = parts.pop() || '';
    const firstName = parts.join(' ') || '';
    lines.push(`N:${lastName};${firstName};;;`);
    lines.push(`FN:${contactPerson}`);
  } else {
    lines.push(`FN:${name}`);
    lines.push(`N:${name};;;;`);
  }
  lines.push(`ORG:${name}`);
  if (contactPosition) lines.push(`TITLE:${contactPosition}`);
  if (phone) lines.push(`TEL;TYPE=WORK,VOICE:${phone}`);
  if (email) lines.push(`EMAIL;TYPE=WORK:${email}`);
  if (website) lines.push(`URL:${website}`);
  if (location) lines.push(`ADR;TYPE=WORK:;;${location};;;;`);
  lines.push('END:VCARD');
  return lines.join('\n');
}

export function VCardQRButton({ lead, size = 'sm', variant = 'ghost', className = '' }) {
  const [open, setOpen] = React.useState(false);
  const vcard = buildVCard(lead);

  const downloadVCard = () => {
    const blob = new Blob([vcard], { type: 'text/vcard;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${(lead.company_name || 'kontakt').replace(/[^a-zA-Z0-9äöüÄÖÜß]/g, '_')}.vcf`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <Button
        variant={variant}
        size={size}
        className={`${className}`}
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        title="vCard QR-Code"
        data-testid={`vcard-qr-btn-${lead.id}`}
      >
        <QrCode className="w-4 h-4" />
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md" onClick={(e) => e.stopPropagation()}>
          <DialogHeader>
            <DialogTitle className="text-center text-lg">{lead.company_name}</DialogTitle>
            <p className="text-center text-sm text-muted-foreground">QR-Code scannen, um Kontakt zu speichern</p>
          </DialogHeader>
          <div className="flex flex-col items-center gap-6 py-4">
            <div className="bg-white p-5 rounded-2xl shadow-lg">
              <QRCodeSVG
                value={vcard}
                size={220}
                level="M"
                includeMargin={false}
                bgColor="#ffffff"
                fgColor="#1a1a1a"
              />
            </div>
            <div className="text-center space-y-1">
              {lead.contact_info?.contact_person && (
                <p className="text-sm font-medium">{lead.contact_info.contact_person}</p>
              )}
              {(lead.contact_info?.general_phone || lead.contact_info?.contact_phone) && (
                <p className="text-xs text-muted-foreground">{lead.contact_info.general_phone || lead.contact_info.contact_phone}</p>
              )}
              {lead.contact_info?.general_email && (
                <p className="text-xs text-muted-foreground">{lead.contact_info.general_email}</p>
              )}
            </div>
            <Button variant="outline" size="sm" onClick={downloadVCard} data-testid="vcard-download-btn">
              <Download className="w-4 h-4 mr-2" /> Als .vcf herunterladen
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
